import { isAfter, isBefore } from 'date-fns';

const handleAfterTicketSalesEnd = ({ entity, allEntities, entityKey, now }) => {
  if (!entity[entityKey]) return false;

  const reference = allEntities.find(tt => tt._id === entity[entityKey]);
  if (!reference || reference.status !== 'enabled') return false;

  const referencedBehavior = reference.availabilityBehavior || 'always_available';

  if (referencedBehavior === 'always_available') return false;

  const behaviorsWithSaleEndOn = [
    'until_event_starts',
    'date_time_based',
    'after_ticket_sale_ends',
    'after_ticket_ends_or_sold_out',
  ];

  if (!behaviorsWithSaleEndOn.includes(referencedBehavior)) return false;

  // If this is nullish then we consider that the referenced ticket has never finished selling
  const saleStartOn = reference.saleEndOn ? new Date(reference.saleEndOn) : null;
  if (!saleStartOn) return false;

  const isAfterStart = isAfter(now, saleStartOn);

  const saleEndOn = entity.saleEndOn ? new Date(entity.saleEndOn) : null;
  const isBeforeEnd = saleEndOn ? isBefore(now, saleEndOn) : true;

  return isAfterStart && isBeforeEnd;
};

export default handleAfterTicketSalesEnd;
